import { FormInput, FormTextArea } from "../../../helpers/AdminHelper";
import { memo } from "react";

const FaqSection = ({ project, updateProject, inputClass }) => {
  const buttonClass = "bg-blue-600 px-2 py-1 rounded";

  const faq = project.faq || [];

  const addFaq = () => {
    updateProject("faq", [
      ...faq,
      {
        question: "",
        answer: "",
      },
    ]);
  };

  const removeFaq = (index) => {
    updateProject(
      "faq",
      faq.filter((_, i) => i !== index),
    );
  };

  const handleChange = (index, field, value) => {
    const updatedFaq = [...faq];
    updatedFaq[index][field] = value;
    updateProject("faq", updatedFaq);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-sm text-slate-300">FAQs</h2>

        <button type="button" onClick={addFaq} className={buttonClass}>
          + Add FAQ
        </button>
      </div>

      {faq.map((item, index) => (
        <div
          key={index}
          className="p-5 rounded-xl border border-white/10 bg-white/5 space-y-4"
        >
          <FormInput
            label={`Question ${index + 1}`}
            placeholder="e.g. How long did this project take to complete?"
            className={inputClass}
            value={item.question}
            onChange={(e) => handleChange(index, "question", e.target.value)}
          />

          <FormTextArea
            label="Answer"
            placeholder="e.g. The project was successfully completed within 45 days without disrupting the client's daily operations."
            rows={4}
            className={inputClass}
            value={item.answer}
            onChange={(e) => handleChange(index, "answer", e.target.value)}
          />

          <button
            type="button"
            onClick={() => removeFaq(index)}
            className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white"
          >
            Remove FAQ
          </button>
        </div>
      ))}
    </div>
  );
};

export default memo(FaqSection);
